import { TherapistAction } from 'src/redux/actions/constant';

const { DISABLE_AUTO_MATCH_FAILURE, DISABLE_AUTO_MATCH_SUCCESS } = TherapistAction;

const intialState: object = {
  response: null,
  errorMessage: null,
  isError: false,
};

export const disableAutoMatchReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case DISABLE_AUTO_MATCH_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        errorMessage: null,
        isError: true,
      };
    }
    case DISABLE_AUTO_MATCH_FAILURE: {
      return {
        ...state,
        response: null,
        errorMessage: action.payload,
        isError: false,
      };
    }

    default:
      return state;
  }
};
